import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'

function mapStateToProps(state, hocProps) {
    return {
        showLoader: state.getIn(['ui', 'userProfile', 'content', 'contents', hocProps.contentId, 'showLoader'], false),
        isLoading: state.getIn(['ui', 'userProfile', 'content', 'contents', hocProps.contentId, 'isLoading'], false),
        isLoaded: state.getIn(['ui', 'userProfile', 'content', 'contents', hocProps.contentId, 'isLoaded'], false),
        data: state.getIn(['ui', 'userProfile', 'content', 'contents', hocProps.contentId, 'data'], Map()),
    }
}

export default (InnerComponent) => {
    @connect(mapStateToProps)
    class hocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocConnect
}
